import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import './_attendanceReport.scss'
import ReportTableData from './ReportTableData'

class EmployeeAttendanceReportSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            branch: "",
            branchError: "",
            year: "",
            yearError: "",

            defaultvalue: 0,
            loadingSpinner: 0,
            currentStep: 1,

            startTime: "",
            endTime: "",

            getYears: [],

            tableHeadMonths: [],
            getEmployeeeAttendanceReport: [],
            attendanceTypes: [],
        }
    }

    handleInputChange = async (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "branch") {

            this.setState({
                branch: value, branchError: "",
                getEmployeeeAttendanceReport: []
            })

            const result = await this.props.client.query({
                query: gql`
                query($institute_id:Int,$branch_id:Int){
                    getYears(institute_id: $institute_id,branch_id:$branch_id) {
                        year
                        yearStart
                        yearEnd
                      }
                }
                `,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: parseInt(value),
                }
            })

            if (result.data.getYears.length > 0) {
                this.setState({
                    getYears: result.data.getYears,
                    year: "",
                    startTime: "",
                    endTime: "",
                    startTime: result.data.getYears[0].yearStart,
                    endTime: result.data.getYears[0].yearEnd,
                    year: result.data.getYears[0].year,
                })
            } else {
                this.setState({
                    getYears: [],
                    year: "",
                    startTime: "",
                    endTime: ""
                })
            }
        }

        if (name == "year") {

            let yearSearchData = this.state.getYears.find((a) => a.year == value);
            this.setState({
                startTime: yearSearchData?.yearStart,
                endTime: yearSearchData?.yearEnd,
                year: value,
                getEmployeeeAttendanceReport: [],
                yearError: ""
            })
        }
    };

    getEmployeeeAttendanceReport = async () => {

        if (this.state.branch == "" || this.state.branch == 0) {
            this.setState({ branchError: "Please select branch" })
            return ""
        }

        if (this.state.year == "" || this.state.year == 0 || this.state.year == undefined) {
            this.setState({ yearError: "Please select Year" })
            return ""
        }

        this.setState({ loadingSpinner: 1 })

        const result = await this.props.client.query({
            query: gql`
            query(
                $institute_id: Int
                $branch_id: Int
                $startTime:String
                $EndTime: String
                $year: Int
                ){
                    getEmployeeeAttendanceReport(
                        institute_id: $institute_id
                        branch_id: $branch_id
                        startTime: $startTime
                        EndTime: $EndTime
                        year: $year
                        ) {
                        employee_id
                        employee_name
                        employee_type
                        employee_stats{
                            total_days
                            present_days
                            absent_days
                            half_days
                            month
                            month_num
                            percentage
                            monthlyReport{
                            date
                            status
                            }
                        }
                        }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
                startTime: this.state.startTime.toString(),
                EndTime: this.state.endTime.toString(),
                year: parseInt(this.state.year),
            }
        })

        if (result.data.getEmployeeeAttendanceReport.length > 0) {

            let months = []

            result.data.getEmployeeeAttendanceReport[0].employee_stats.map((item) => {
                months.push(item.month)
            })


            this.setState({
                getEmployeeeAttendanceReport: result.data.getEmployeeeAttendanceReport,
                loadingSpinner: 0,
                tableHeadMonths: months
            })
        } else {
            this.setState({
                getEmployeeeAttendanceReport: [],
                loadingSpinner: 0,
            })
        }
    }

    render() {
        console.log("wewewewewewe", this.state.startTime, this.state.endTime)
        return (
            <Container className="Employee_attendance_report">
                <Row className="mt-3">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">Employee Attendance Report</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                    <Form.Label className="text-uppercase font-weight-bold">Select Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value={this.state.defaultvalue}>--Select Branch--</option>
                                        {this.props.globals.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                    <Form.Label className="text-uppercase font-weight-bold">Select Year</Form.Label>
                                    <Form.Control as="select" name="year" onChange={(e) => this.handleInputChange(e)} value={this.state.year}>
                                        <option value={this.state.defaultvalue}>--Select Year--</option>
                                        {this.state.getYears.map(branchData => (
                                            <option value={branchData.year}>{branchData.year}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.yearError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                    <Button className="btn btn-success text-uppercase submit_btn" onClick={(e) => this.getEmployeeeAttendanceReport()}>Submit</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>

                {
                    this.state.getEmployeeeAttendanceReport.length > 0 ?
                        (
                            <>

                                <h5 className="mt-3 text-center">Employee wise Attendance Report</h5>
                                <Row className="mt-3">
                                    <ReportTableData
                                        stateData={this.state}
                                    />
                                </Row>
                            </>
                        )
                        :
                        (
                            <Container>
                                <Row>
                                    <Col sm={12}>
                                        <div className={this.state.loadingSpinner == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""} >
                                        </div>
                                    </Col >
                                </Row>
                            </Container >
                        )
                }


            </Container>
        )
    }
}

export default withRouter(withApollo(
    compose(

    )(EmployeeAttendanceReportSection))
);
